import { Star } from "lucide-react";
import { REVIEWS, GOOGLE_REVIEW_URL } from "@/data/reviews";

export function Reviews() {
  const hasReviews = REVIEWS.length > 0;
  return (
    <section id="velemenyek" className="relative z-10 px-6 lg:px-10 py-16 md:py-24">
      <div className="max-w-7xl mx-auto">
        {hasReviews && (
          <>
            <div className="text-xs uppercase tracking-[0.3em] text-primary mb-4">▸ Vélemények</div>
            <h2 className="font-display text-5xl md:text-7xl leading-[0.9] mb-10">Ügyfeleink mondták</h2>
            <div className="grid gap-6 md:grid-cols-3 mb-10">
              {REVIEWS.map((r) => (
                <figure key={r.name + r.date} className="rounded-2xl border border-border bg-surface p-6">
                  <div className="flex gap-1 mb-3 text-primary" aria-label={`${r.rating} / 5 csillag`}>
                    {Array.from({ length: 5 }).map((_, i) => (
                      <Star key={i} className="h-4 w-4" fill={i < r.rating ? "currentColor" : "none"} />
                    ))}
                  </div>
                  <blockquote className="text-muted-foreground mb-4">„{r.text}"</blockquote>
                  <figcaption className="text-sm">
                    <span className="font-semibold">{r.name}</span>{" "}
                    <span className="text-muted-foreground">· {new Date(r.date).toLocaleDateString("hu-HU")}</span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </>
        )}
        <div className="flex justify-center">
          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-primary px-6 py-3 text-sm uppercase tracking-wider text-primary hover:bg-primary hover:text-primary-foreground transition-colors"
          >
            <Star className="h-4 w-4" /> Írj értékelést a Google-on
          </a>
        </div>
      </div>
    </section>
  );
}

/** JSON-LD only when real reviews exist. */
export function reviewSchemaScripts() {
  if (REVIEWS.length === 0) return [];
  const avg = REVIEWS.reduce((s, r) => s + r.rating, 0) / REVIEWS.length;
  return [
    {
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "AutoRepair",
        "@id": "https://lakroszautoszerviz.com/#autorepair",
        name: "LAKROSZ Autószerviz",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: avg.toFixed(1),
          reviewCount: REVIEWS.length,
          bestRating: 5,
        },
        review: REVIEWS.map((r) => ({
          "@type": "Review",
          author: { "@type": "Person", name: r.name },
          datePublished: r.date,
          reviewBody: r.text,
          reviewRating: { "@type": "Rating", ratingValue: r.rating, bestRating: 5 },
        })),
      }),
    },
  ];
}
